import { AppThunkAction } from './index';
import { appConfig } from '../config';
import { showToast } from 'src/reducers/slices/toast';
import { AppVersion } from 'src/appVersion';

const appVersion: AppVersion = AppVersion.parse(appConfig.REACT_APP_VERSION);

type AllowedVariant = 'success' | 'warning' | 'error' | 'info';

function isAllowedVariant(value?: string): value is AllowedVariant {
  return ['success', 'warning', 'error', 'info'].includes(value ?? '');
}

export const showSnackBarMsg = (msg: $TSFixMe, variant?: string, title?: string): AppThunkAction => {
  if (appVersion.isMajor(3)) {
    return (dispatch) => {
      dispatch(
        showToast({
          title,
          message: msg,
          variant: isAllowedVariant(variant) ? variant : 'info',
        })
      );
    };
  }

  return (dispatch, getState) => {
    dispatch({ type: 'ADD_SNACKBAR', msg, variant });
    if (getState().snackbar.open === true) {
      dispatch({ type: 'CLOSE_SNACKBAR' });
    } else {
      dispatch({ type: 'PROCESS_SNACKBAR_QUEUE' });
    }
  };
};

export function hideSnackBarMsg(): AppThunkAction {
  return (dispatch) => {
    dispatch({
      type: 'CLOSE_SNACKBAR',
    });
  };
}

export function processSnackbarQueue(): AppThunkAction {
  return (dispatch) => {
    dispatch({
      type: 'PROCESS_SNACKBAR_QUEUE',
    });
  };
}
